export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);

export const resolveProductImage = (source) => {
  const url = String(source || "").trim();
  if (!url || /^(https?:|data:|blob:)/i.test(url)) return url;
  if (url.startsWith("/uploads/")) {
    return `${process.env.REACT_APP_BACKEND_URL || ""}${url}`;
  }
  return url;
};

export const calcDiscountPct = (price, original) => {
  if (!original || original <= price) return 0;
  return Math.round(((original - price) / original) * 100);
};

export const CATEGORIES = [
  { slug: "men", label: "Men" },
  { slug: "women", label: "Women" },
  { slug: "unisex", label: "Unisex" },
  { slug: "couple", label: "Couple Tees" },
  { slug: "oversized", label: "Oversized" },
  { slug: "graphic", label: "Graphic" },
  { slug: "anime", label: "Anime" },
  { slug: "custom", label: "Custom" },
];

const categoryBySlug = Object.fromEntries(CATEGORIES.map((category) => [category.slug, category]));
const categorySlugByLabel = Object.fromEntries(CATEGORIES.map((category) => [category.label.toLowerCase(), category.slug]));
const categoryAliases = {
  "couple tee": "couple",
  "couple tees": "couple",
  "custom design": "custom",
  "custom designs": "custom",
};

export const getCategorySlug = (value) => {
  const clean = String(value || "").trim().toLowerCase();
  if (!clean) return "";
  if (categoryBySlug[clean]) return clean;
  if (categorySlugByLabel[clean]) return categorySlugByLabel[clean];
  if (categoryAliases[clean]) return categoryAliases[clean];
  return clean.replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
};

export const getCategoryLabel = (value) => {
  const slug = getCategorySlug(value);
  return categoryBySlug[slug]?.label || String(value || "").trim() || "Streetwear";
};

export const getProductCategories = (product = {}) => {
  const raw = Array.isArray(product.categories) && product.categories.length
    ? product.categories
    : product.category
      ? [product.category]
      : [];
  const seen = new Set();
  return raw
    .map(getCategoryLabel)
    .filter(Boolean)
    .filter((label) => {
      const slug = getCategorySlug(label);
      if (!slug || seen.has(slug)) return false;
      seen.add(slug);
      return true;
    });
};

export const productHasCategory = (product = {}, category) => {
  const slug = getCategorySlug(category);
  if (!slug || slug === "all") return true;
  return getProductCategories(product).some((label) => getCategorySlug(label) === slug);
};
